function buildBreakpoints() {

	/**
	 * The list of available breakpoints.
	 *
	 * @var {object}
	 */
	const breakpoints = {
		'phone-xsmall': 320,
		'phone-small': 425,
		'phone-medium': 600,
		'phone': 768,
		'tablet': 1024,
		'desktop-small': 1200,
		'desktop-medium': 1440,
		'desktop-mlarge': 1600,
		'desktop-large': 1800,
		'desktop-xlarge': 1920,
		'desktop-max': 2000
	};

	return Object.freeze({
		current,
		get,
		is
	});

	/**
	 * Retrieves the current breakpoint.
	 *
	 * @since 2.8.0
	 *
	 * @return {string}
	 */
	function current () {
		const { innerWidth: vw } = window;

		const [currentBreakpoint] = Object.keys( breakpoints ).filter( bp => vw >= breakpoints[ bp ]).reverse();

		return currentBreakpoint;
	}

	/**
	 * Retrieves the specified breakpoint.
	 *
	 * @since 2.8.0
	 *
	 * @param {string} breakpoint
	 * @return {number|null}
	 */
	function get ( breakpoint ) {
		return breakpoints[ breakpoint ] || null;
	}

	/**
	 * Checks if the current breakpoint meets the specified criteria.
	 *
	 * @since 2.8.0
	 *
	 * @param {string} criteria
	 * @param boolean
	 */
	function is ( criteria ) {
		const operator = criteria.replace( /[a-z\-\s]/g, '' );
		const selectedBreakpoint = criteria.replace( operator, '' ).trim();

		const currentB = breakpoints[ current() ];
		const selectedB = breakpoints[ selectedBreakpoint ];

		if ( ! operator ) return currentB === selectedB;

		const compare = {
			'>': ( a, b ) => a > b,
			'>=': ( a, b ) => a >= b,
			'<': ( a, b ) => a < b,
			'<=': ( a, b ) => a <= b
		};

		return compare[ operator ]( currentB, selectedB );
	}
}

export const breakpoint = buildBreakpoints();